/** Namespace `dashboard` — wird befüllt während der Komponenten-Migration. */
export const dashboard = {
  de: {
    dashboard: {
      greetingMorning: 'Guten Morgen',
      greetingDay: 'Guten Tag',
      greetingEvening: 'Guten Abend',
      eyebrow: 'Palma de Mallorca',
      todayIntro: 'Dein Überblick — heute ist <1>{{date}}</1>.',
      errorLoad: 'Dashboard-Daten konnten nicht geladen werden',
      statTodaysAppointments: 'Termine heute',
      statCompleted: 'Abgeschlossen',
      statPendingConfirmations: 'Offene Bestätigungen',
      statNoShows: 'Nicht erschienen',
      // Self-Service-Aktionen von Patienten
      patientActionsTitle: 'Patienten-Aktionen der letzten 7 Tage ({{count}})',
      patientActionCancelled: 'Abgesagt',
      patientActionRescheduled: 'Verschoben',
      patientActionAck: 'Erledigt',
      patientActionAckTitle: 'Als erledigt markieren',
      patientActionAcked: 'Erledigt · {{name}}',
      patientActionUndo: 'Rückgängig',
      patientActionsAllDone: 'Alle erledigt',
      patientActionsShowAcked: '{{count}} erledigte anzeigen',
      patientActionsHideAcked: 'Erledigte ausblenden',
      patientActionAckedBadge: 'erledigt',
      googleOnlySubtitle: '{{count}} davon nur in Google',
      statusConfirmed: 'Bestätigt',
      statusPending: 'Offen',
      statusScheduled: 'Geplant',
      statusCompleted: 'Abgeschlossen',
      statusCancelled: 'Storniert',
      statusNoShow: 'Nicht erschienen',
      googleBannerTitle: 'Aus Google Calendar nicht erfasst',
      googleBannerText:
        '<1>{{count}}</1> anstehende(s) Event(s) liegen nur im Google Calendar und sind nicht als App-Termin erfasst. Du kannst sie einzeln im Kalender editieren oder per Bulk-Import als App-Termine übernehmen.',
      importAll: 'Alle importieren…',
      googleBannerShow: 'Events anzeigen',
      googleBannerHide: 'Events ausblenden',
      googleBannerNoTitle: '(ohne Titel)',
      googleBannerAllDay: 'ganztägig',
      googleBannerOpenInGoogle: 'In Google öffnen',
      loadMastersError: 'Konnte Stammdaten nicht laden.',
      selectAllError: 'Bitte Behandler, Behandlung und Raum auswählen.',
      importToast: '✅ {{converted}} importiert, {{skipped}} übersprungen{{errorsSuffix}}.',
      importErrorsSuffix: ', {{count}} Fehler',
      importFailed: 'Import fehlgeschlagen.',
      importModalTitle: 'Google-Events als App-Termine importieren',
      importModalText:
        'Default-Werte für alle <1>{{count}}</1> Events. Du kannst die App-Termine danach einzeln anpassen.',
      importSource: 'Quelle',
      importSourceMain: 'Hauptkalender (info@seadent.es)',
      importSourceExtra: 'Zusatzkalender: {{id}}',
      importSourceExtraHint:
        'Übernimmt die Termine aus dem Zusatzkalender als App-Termine: Jeder Termin bekommt eine Kopie im Hauptkalender; die Originale im Zusatzkalender bleiben unverändert. Zeitliche Überschneidungen werden bewusst zugelassen.',
      defaultProvider: 'Standard-Behandler',
      selectProvider: 'Behandler wählen…',
      defaultProcedure: 'Standard-Behandlung',
      selectProcedure: 'Behandlung wählen…',
      defaultOperatory: 'Standard-Raum',
      selectOperatory: 'Raum wählen…',
      importWarning:
        '⚠️ Achtung: Termine werden als scheduled angelegt. Bei zeitlichen Überschneidungen mit anderen scheduled/confirmed-Terminen wird ein Import übersprungen — diese siehst du in der Browser-Konsole.',
      importing: 'Importiere…',
      importNow: 'Jetzt importieren',
      pendingTitle: 'Neue Buchungen über seadent.es',
      pendingSubtitle: '{{count}} ausstehend — bitte bestätigen oder ablehnen',
      website: 'Website',
      openInCalendar: 'Im Kalender öffnen',
      upcomingTitle: 'Anstehende Termine',
      qrAction: 'Anamnese-QR anzeigen',
      invoiceAction: 'Rechnung erstellen',
      qrTitle: 'Anamnesebogen',
      qrInstruction: 'Mit der Handy-Kamera scannen, um den Anamnesebogen auszufüllen.',
      qrClose: 'Schließen',
      upcomingSubtitle: 'Nächste 7 Tage — App-Termine und Google-Calendar-Events',
      noUpcoming: 'Keine anstehenden Termine',
      noTitle: '(ohne Titel)',
      openInCalendarGoogle: 'Im Kalender öffnen (Event nur in Google Calendar)',
      onlyInGoogle: 'Nur in Google Calendar',
      allDay: 'ganztägig',
      google: 'Google',
      quickAccess: 'Schnellzugriff',
      quickCalendar: 'Kalender',
      quickCalendarDesc: 'Termine verwalten',
      quickAppointments: 'Terminliste',
      quickAppointmentsDesc: 'Alle Termine filtern',
      quickProviders: 'Behandler',
      quickProvidersDesc: 'Team & Kalender',
      // Mini-CRM: fehlgeschlagene Mails (Badge)
      failedMails: '{{count}} E-Mail(s) fehlgeschlagen (7 Tage)',
      failedMailsHint: 'Details in der Patientenakte',
    },
  },
  es: {
    dashboard: {
      greetingMorning: 'Buenos días',
      greetingDay: 'Buenas tardes',
      greetingEvening: 'Buenas noches',
      eyebrow: 'Palma de Mallorca',
      todayIntro: 'Su resumen — hoy es <1>{{date}}</1>.',
      errorLoad: 'No se pudieron cargar los datos del panel',
      statTodaysAppointments: 'Citas de hoy',
      statCompleted: 'Completadas',
      statPendingConfirmations: 'Confirmaciones pendientes',
      statNoShows: 'No asistieron',
      // Acciones de autoservicio de pacientes
      patientActionsTitle: 'Acciones de pacientes en los últimos 7 días ({{count}})',
      patientActionCancelled: 'Cancelada',
      patientActionRescheduled: 'Cambiada',
      patientActionAck: 'Hecho',
      patientActionAckTitle: 'Marcar como hecho',
      patientActionAcked: 'Hecho · {{name}}',
      patientActionUndo: 'Deshacer',
      patientActionsAllDone: 'Todo hecho',
      patientActionsShowAcked: 'Mostrar {{count}} hechas',
      patientActionsHideAcked: 'Ocultar hechas',
      patientActionAckedBadge: 'hecho',
      googleOnlySubtitle: '{{count}} de ellas solo en Google',
      statusConfirmed: 'Confirmada',
      statusPending: 'Pendiente',
      statusScheduled: 'Programada',
      statusCompleted: 'Completada',
      statusCancelled: 'Cancelada',
      statusNoShow: 'No asistió',
      googleBannerTitle: 'No registrado desde Google Calendar',
      googleBannerText:
        '<1>{{count}}</1> evento(s) próximos están solo en Google Calendar y no están registrados como cita de la aplicación. Puede editarlos individualmente en el calendario o importarlos en bloque como citas de la aplicación.',
      importAll: 'Importar todos…',
      googleBannerShow: 'Mostrar eventos',
      googleBannerHide: 'Ocultar eventos',
      googleBannerNoTitle: '(sin título)',
      googleBannerAllDay: 'todo el día',
      googleBannerOpenInGoogle: 'Abrir en Google',
      loadMastersError: 'No se pudieron cargar los datos maestros.',
      selectAllError: 'Por favor, seleccione doctor, tratamiento y sala.',
      importToast: '✅ {{converted}} importadas, {{skipped}} omitidas{{errorsSuffix}}.',
      importErrorsSuffix: ', {{count}} errores',
      importFailed: 'Error en la importación.',
      importModalTitle: 'Importar eventos de Google como citas de la aplicación',
      importModalText:
        'Valores predeterminados para todos los <1>{{count}}</1> eventos. Después podrá ajustar las citas individualmente.',
      importSource: 'Origen',
      importSourceMain: 'Calendario principal (info@seadent.es)',
      importSourceExtra: 'Calendario adicional: {{id}}',
      importSourceExtraHint:
        'Convierte las citas del calendario adicional en citas de la aplicación: cada cita recibe una copia en el calendario principal; los originales permanecen sin cambios. Los solapamientos se permiten deliberadamente.',
      defaultProvider: 'Doctor predeterminado',
      selectProvider: 'Seleccionar doctor…',
      defaultProcedure: 'Tratamiento predeterminado',
      selectProcedure: 'Seleccionar tratamiento…',
      defaultOperatory: 'Sala predeterminada',
      selectOperatory: 'Seleccionar sala…',
      importWarning:
        '⚠️ Atención: las citas se crean como scheduled. En caso de solapamientos con otras citas scheduled/confirmed, la importación se omite — las verá en la consola del navegador.',
      importing: 'Importando…',
      importNow: 'Importar ahora',
      pendingTitle: 'Nuevas reservas a través de seadent.es',
      pendingSubtitle: '{{count}} pendientes — por favor, confirme o rechace',
      website: 'Sitio web',
      openInCalendar: 'Abrir en el calendario',
      upcomingTitle: 'Próximas citas',
      qrAction: 'Mostrar QR del cuestionario',
      invoiceAction: 'Crear factura',
      qrTitle: 'Cuestionario de anamnesis',
      qrInstruction: 'Escanee el código con la cámara del móvil para rellenar el cuestionario.',
      qrClose: 'Cerrar',
      upcomingSubtitle: 'Próximos 7 días — citas de la aplicación y eventos de Google Calendar',
      noUpcoming: 'No hay citas próximas',
      noTitle: '(sin título)',
      openInCalendarGoogle: 'Abrir en el calendario (evento solo en Google Calendar)',
      onlyInGoogle: 'Solo en Google Calendar',
      allDay: 'todo el día',
      google: 'Google',
      quickAccess: 'Acceso rápido',
      quickCalendar: 'Calendario',
      quickCalendarDesc: 'Gestionar citas',
      quickAppointments: 'Lista de citas',
      quickAppointmentsDesc: 'Filtrar todas las citas',
      quickProviders: 'Doctores',
      quickProvidersDesc: 'Equipo y calendario',
      // Mini-CRM: correos fallidos (badge)
      failedMails: '{{count}} correo(s) fallido(s) (7 días)',
      failedMailsHint: 'Detalles en la historia clínica',
    },
  },
};
